import { render, staticRenderFns } from "./SubjectList.vue?vue&type=template&id=db07e8da&scoped=true&"
import script from "./SubjectList.vue?vue&type=script&lang=js&"
export * from "./SubjectList.vue?vue&type=script&lang=js&"
import style0 from "./SubjectList.vue?vue&type=style&index=0&id=db07e8da&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db07e8da",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VBtnToggle } from 'vuetify/lib/components/VBtnToggle';
import { VChip } from 'vuetify/lib/components/VChip';
import { VDataTable } from 'vuetify/lib/components/VDataTable';
import { VIcon } from 'vuetify/lib/components/VIcon';
installComponents(component, {VBtn,VBtnToggle,VChip,VDataTable,VIcon})
